import React, { useState, useEffect, useRef } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import axios from "axios";
import { Bell, TrashFill } from "react-bootstrap-icons";
import NotificationDeleteOne from "./modals/NotificationDeleteOne";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import "./Notifications.css";
import { useNavigate } from "react-router-dom";

export default function Notifications({ refreshData,closeNoteAndInbox }) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeModal, setActiveModal] = useState(false);
  const [tempId, setTempId] = useState(0);
  const [skip, setSkip] = useState(0);
  const [noMoreNotifications, setNoMoreNotifications] = useState(false);
  const { user } = useAuthContext();
  const navi = useNavigate();
  const notificationRef = useRef(null);

  const ViewMoreNotifications = async () => {
    const newSkip = skip + 25;
    try {
      const noteResponse = await axios.get(
        `${ApiConnectionString}/api/notifications?Skip=${newSkip}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (noteResponse.data.length === 0) {
        setNoMoreNotifications(true);
      }

      setNotifications((prevNots) => [...prevNots, ...noteResponse.data]);
      setSkip(newSkip);
    } catch (error) {
      console.error("Error fetching more notifications:", error);
    }
  };

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${ApiConnectionString}/api/notifications?Skip=0`,
        {
          headers: { Authorization: `bearer ${user.token}` },
        }
      );

      const sortedNotifications = response.data.sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
      );
      setNotifications(sortedNotifications);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
      refreshData();
    }
  };

  const removeObject = (notid) => {
    setNotifications((prevNotifications) =>
      prevNotifications.filter((notification) => notification.id !== notid)
    );
  };

  const cancelModal = () => {
    setTempId(0);
    setActiveModal(false);
  };

  const handleDelete = (id) => {
    setTempId(id);
    setActiveModal(true);
  };

  useEffect(() => {
    fetchNotifications();
  }, [user]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        closeNoteAndInbox()
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  if (loading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div ref={notificationRef} className="m-0 p-0 notification-scroll">
      <div className="blueBanner">
        <p className="fw-bold p-2">Notifications</p>
      </div>
      {notifications.map((notification) => (
        <div  onClick={() => {navi(`/notification/${notification.id}`);closeNoteAndInbox()}} className="d-flex justify-content-center text-center" key={notification.id}>
          <div
            className={`notification-item border ${
              notification.read ? "read" : "unread"
            }`}
          >
            <p className="mb-0">{notification.title}</p>

            <p className="text-muted mt-0">
              {new Date(notification.timestamp).toLocaleDateString()} {" "}
              {new Date(notification.timestamp).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </p>

            <p className="notification-content">{notification.content}</p>

            <div className="d-flex justify-content-between">
              <span>{notification.read ? "Read" : "Unread"}</span>
              <TrashFill
                size={25}
                onClick={(event) => {
                  event.stopPropagation();
                  handleDelete(notification.id);
                }}
              />
            </div>
          </div>
        </div>
      ))}

      <hr className="p-1 m-1" />

      {notifications.length === 0 && (
        <div className="no-messages-container">
          <Bell size={40} />
          <p className="no-notifications-text">No Notifications yet</p>
          <p className="text-muted">New notifications will appear here</p>
        </div>
      )}

      <div className="text-center d-flex justify-content-center">
        {notifications.length !== 0 &&
          (!noMoreNotifications ? (
            <p onClick={ViewMoreNotifications} className="saveChanges-button">
              View More
            </p>
          ) : (
            <p className="text-muted">No more notifications</p>
          ))}
      </div>

      {activeModal && (
        <NotificationDeleteOne
          cancelModal={cancelModal}
          id={tempId}
          removeObject={removeObject}
        />
      )}
    </div>
  );
}
